import React, { useCallback } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Form, Select } from 'antd'
import { map } from 'lodash-es'
import {
  createUrl,
  getQueryParams,
} from '../../../../core/utils/services/queryParams'
import { SCRAPING_SESSION_STATUSES } from '../../../constants'

const style = {
  width: '100%',
}

const ScrapingSessionStatusFilter = () => {
  const history = useHistory()
  const { pathname, search } = useLocation()

  const { status } = getQueryParams(search)

  const handleChange = useCallback(
    status =>
      history.push(
        createUrl(pathname, search, {
          status,
        }),
      ),
    [history, pathname, search],
  )

  return (
    <Form.Item label="Status" labelCol={{ span: 24 }}>
      <Select style={style} allowClear value={status} onChange={handleChange}>
        {map(SCRAPING_SESSION_STATUSES, ({ name, value }) => (
          <Select.Option key={value} value={value}>
            {name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  )
}

export default ScrapingSessionStatusFilter
